import React from "react";
import {
  Box,
  Button,
  CardActions,
  IconButton,
  Typography,
  CardMedia,
  CardContent,
  Card,
} from "convertupleads-theme";
import { HeartIcon } from "../../../../common/Icons/Icons";

const MediaCardPrimary = () => {
  return (
    <Card sx={{ maxWidth: 345 }}>
      <Box sx={{ p: 2 }}>
        <CardMedia
          component="img"
          height="140"
          sx={{ borderRadius: "4px" }}
          image="https://images.unsplash.com/photo-1498050108023-c5249f4df085?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=872&q=80"
          alt="green iguana"
        />
      </Box>
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          Lizard
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Lizards are a widespread group of squamate reptiles, with over 6,000
          species, ranging across all continents except Antarctica
        </Typography>
      </CardContent>

      <CardActions sx={{ justifyContent: "space-between", p: 2 }}>
        <Button size="small" color="primary">
          Read More ...
        </Button>
        <IconButton>
          <HeartIcon color={"primary"} />
        </IconButton>
      </CardActions>
    </Card>
  );
};

export default MediaCardPrimary;
